// extracted by mini-css-extract-plugin
export var button = "_5-0";
export var buttonContent = "_5-e";
export var buttonGroup = "_5-c";
export var dontRestrainIconWidth = "_5-a";
export var dropdownButton = "_5-b";
export var iconContainer = "_5-9";
export var lg = "_5-4";
export var md = "_5-3";
export var pending = "_5-f";
export var sm = "_5-2";
export var spinner = "_5-d";
export var squared = "_5-8";
export var wrapText = "_5-g";
export var xl = "_5-5";
export var xs = "_5-1";
export var xxl = "_5-6";
export var xxxl = "_5-7";